import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { t } from "i18next";
import React from "react";
import { CSRDQuestionnaire } from "../../CSRDQuestionnaire";

function ReviewCSRDQuestionnaireModal({ isOpen, onClose, questionnaireId }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("dataEntryPlanning.reviewQuestionnaireModal.title")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <CSRDQuestionnaire questionnaireId={questionnaireId} isOpenedInModal={true} />
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("dataEntryPlanning.reviewQuestionnaireModal.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ReviewCSRDQuestionnaireModal